<template lang="pug">
section.hero.is-small.is-primary.is-bold
    .hero-head
      header.nav
        .container
          nav.navbar.is-transparent
            .navbar-brand
              a.navbar-item.is-active
                .subtitle
                  strong QuijoteLui
              a.navbar-item.is-active
                router-link.nav-item(:to = "{ name: 'menu' }") 
                  p.menu-item 
                    strong &#9751; Inicio
              a.navbar-item.is-active
                router-link.nav-item(to = "empresa") 
                  p.menu-item
                    strong Empresa
              a.navbar-item.is-active(v-if = "showNotification")
                router-link.nav-item(to = "parametro") 
                  p.menu-item
                    strong Parámetros
              a.navbar-item.is-active
                router-link.nav-item(to = "about")  
                  p.menu-item
                    strong Acerca   
              a.navbar-item.is-active
                router-link.nav-item(to = "salir")  
                  p.menu-item
                    strong Salir     
</template>

<script>
export default {
  
  data: () => ({
    showNotification: false
  }),

  beforeMount () {
    if (localStorage.getItem('token')) {
      let usuario = JSON.parse(localStorage.getItem('usuario'))
      
      usuario.roles.forEach((rol) => {
        if (rol === 'ADMIN')
          this.showNotification = true
      })
      
    }
  }
}
</script>

<style lang="scss">
p.menu-item {
  text-align: center;
  color: white;
}
</style>
